interface LoadingSpinnerProps {
    size?: 'sm' | 'md' | 'lg';
    fullScreen?: boolean;
    message?: string;
}

const LoadingSpinner = ({
    size = 'md',
    fullScreen = false,
    message = 'Loading...',
}: LoadingSpinnerProps) => {
    const sizeClasses = {
        sm: 'spinner-border-sm',
        md: '',
        lg: 'spinner-border spinner-border-lg',
    };

    const containerClass = fullScreen
        ? 'position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-light bg-opacity-75'
        : 'd-flex justify-content-center align-items-center';

    const containerStyle = fullScreen
        ? { zIndex: 9999 }
        : { minHeight: '300px' };

    return (
        <div className={containerClass} style={containerStyle}>
            <div className="text-center">
                <div
                    className={`spinner-border text-primary ${sizeClasses[size]}`}
                    role="status"
                >
                    <span className="visually-hidden">{message}</span>
                </div>
                {message && <div className="mt-2 text-muted">{message}</div>}
            </div>
        </div>
    );
};

export default LoadingSpinner;
